import oAxiosInstance from "config/Axios";

export const apiCallConfigUpdateNumbers = () => {
  return oAxiosInstance.get("herramientas/actualizarNumeradores");
};

export const apiCallConfigOptimizeCfe = () => {
  return oAxiosInstance.get("herramientas/optimizardocumentos");
};
export const apiCallImportarCfe = () => {
  return oAxiosInstance.get("efactura/cfe/recibidos/importar");
};

export const apiCallConfigGetParameter = (sName) => {
  return oAxiosInstance.get(`parametros/${sName}`);
};

export const apiCallConfigUpdateParameter = (sName, sValue) => {
  return oAxiosInstance.put(`parametros/${sName}`, { parVal: sValue });
};
